export default __webpack_public_path__ + "static/media/178.ceba3c14.png";